import {
  createPropController
} from "../prop-controllers/instances";
import { PropController } from "../prop-controllers/base";
import {
  getTranslatableData,
  mergeTranslatedData
} from "./control";
import { copy as controlCopy } from "./control";
import {
  getElementChildren,
  getFileIds,
  getPageIds,
  getSwatchIds,
  getTypographyIds
} from "../prop-controllers/introspection";
const ListControlType = "makeswift::controls::list";
function List(config) {
  return { type: ListControlType, config };
}
const ListControlMessageType = {
  LIST_CONTROL_ITEM_CONTROL_MESSAGE: "makeswift::controls::list::message::item-control-message"
};
class ListControl extends PropController {
  controls;
  descriptor;
  send;
  constructor(send, descriptor) {
    super(send);
    this.descriptor = descriptor;
    this.send = send;
    this.controls = /* @__PURE__ */ new Map();
  }
  setItemsControl = (value) => {
    const controls = /* @__PURE__ */ new Map();
    if (value == null)
      return;
    const shouldUpdate = () => {
      if (value.length !== this.controls.size)
        return true;
      if (!value.every(({ id }) => this.controls.has(id)))
        return true;
      return false;
    };
    if (!shouldUpdate())
      return this.controls;
    value.forEach((item) => {
      const control = createPropController(
        this.descriptor.config.type,
        (message) => this.send({
          type: ListControlMessageType.LIST_CONTROL_ITEM_CONTROL_MESSAGE,
          payload: { message, itemId: item.id }
        })
      );
      controls.set(item.id, control);
    });
    this.controls = controls;
    return this.controls;
  };
  recv = (message) => {
    switch (message.type) {
      case ListControlMessageType.LIST_CONTROL_ITEM_CONTROL_MESSAGE: {
        const control = this.controls.get(message.payload.itemId);
        if (control == null)
          return;
        const recv = control.recv;
        recv(message.payload.message);
      }
    }
  };
}
function copyListData(definition, value, context) {
  if (value == null)
    return value;
  return value && value.map((item) => ({
    ...item,
    value: controlCopy(definition.config.type, item.value, context)
  }));
}
function introspectListData(definition, value, func) {
  if (value == null)
    return [];
  return value.flatMap((item) => func(definition.config.type, item.value));
}
function getListElementChildren(definition, value) {
  return introspectListData(definition, value, getElementChildren);
}
function getListSwatchIds(definition, value) {
  return introspectListData(definition, value, getSwatchIds);
}
function getListFileIds(definition, value) {
  return introspectListData(definition, value, getFileIds);
}
function getListTypographyIds(definition, value) {
  return introspectListData(definition, value, getTypographyIds);
}
function getListPageIds(definition, value) {
  return introspectListData(definition, value, getPageIds);
}
function getListTranslatableData(definition, data) {
  return Object.fromEntries(
    data.map((item) => [item.id, getTranslatableData(definition.config.type, item.value)])
  );
}
function mergeListTranslatedData(definition, data, translatedData, context) {
  return data.map((item) => {
    return {
      ...item,
      value: mergeTranslatedData(
        definition.config.type,
        item.value,
        translatedData[item.id],
        context
      )
    };
  });
}
export {
  List,
  ListControl,
  ListControlMessageType,
  ListControlType,
  copyListData,
  getListElementChildren,
  getListFileIds,
  getListPageIds,
  getListSwatchIds,
  getListTranslatableData,
  getListTypographyIds,
  mergeListTranslatedData
};
//# sourceMappingURL=list.js.map